import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { Button } from 'react-bootstrap';
import Background from '../../assets/img/kycBG.svg';
import { DeleteForever } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { DocumentsnannyList } from '../../store/apiSlice/DocumentsnannySlice';
import { uploadFile } from '../../store/apiSlice/uploadFileSlice';
import { clearData, uploadDocuments } from '../../store/apiSlice/UpdateDocumentSlice';
import { ClipLoader } from 'react-spinners';
import fileIcon from '../../assets/img/eye.png'

const Documentsnanny = () => {

    const dispatch = useDispatch();
    const Uploaddocumentdata = useSelector((state) => state.rootReducer.DocumentsnannyReducer.data);
    const uploadFileData = useSelector((state) => state.rootReducer.uploadFileReducer.data);
    const uploadDocumentData = useSelector((state) => state.rootReducer.uploadDocumentsReducer.data);
    const [loading, setLoading] = useState(false)
    const [updateImageIndex, setUpdateImageIndex] = useState(-1)

    const [documents, setDocuments] = useState([{
        name: "",
        link: "",
        thumbnailLink: ""
    }])

    useEffect(() => {
        dispatch(DocumentsnannyList())
    }, [])


    useEffect(() => {
        if (Uploaddocumentdata != null && Uploaddocumentdata.status === 1) {
            setLoading(false)
            const sanitizedDocs = Uploaddocumentdata.data.documents.map(doc => ({
                name: doc.name ?? "",
                link: doc.link ?? "",
                thumbnailLink: doc.thumbnailLink ?? ""
            }));
            setDocuments(sanitizedDocs);
        }
    }, [Uploaddocumentdata])

    const addDiv = () => {
        if (loading) {
            alert('Please wait!')
            return
        }
        setDocuments([...documents, {
            name: "",
            link: "",
            thumbnailLink: ""
        }]);
    };
    const removeDiv = (indexToRemove) => {

        const prevDocuments = [...documents]
        prevDocuments.splice(indexToRemove, 1)
        setDocuments(prevDocuments)
        let valid = false;
        for (let doc of prevDocuments) {
            if (doc.name && doc.link && documents[indexToRemove]?.createdAt) {
                valid = true
            }
        }
        if (valid || prevDocuments.length === 0) {
            setLoading(true)
            dispatch(uploadDocuments({
                "documents": prevDocuments
            }));
        }
    };

    const setDocumentName = (newName, index) => {
        setDocuments(documents => {
            const updatedDocuments = [...documents];
            updatedDocuments[index] = { ...updatedDocuments[index], name: newName };
            return updatedDocuments;
        });
    }

    const setDocumentImage = (pan_image_path, index) => {
        if (pan_image_path && index !== null) {
            setUpdateImageIndex(index)
            setLoading(true)
            dispatch(uploadFile(pan_image_path))
        }
    }

    const handleDocuments = () => {
        for (let doc of documents) {
            if (!doc.name || !doc.link) {
                alert('Please fill document name and select an attachment')
                return
            }
        }

        try {
            dispatch(uploadDocuments({
                "documents": documents
            }));
        } catch (e) {
            alert("Please add all documents and its name!")
        }
    };

    useEffect(() => {
        if (uploadFileData != null && updateImageIndex > -1) {
            setDocuments(documents => {
                const updatedDocuments = [...documents];
                updatedDocuments[updateImageIndex] = { ...updatedDocuments[updateImageIndex], link: uploadFileData.Location };
                return updatedDocuments;
            });
            alert("Please click on save to upload the document!")
            setLoading(false)
        }
    }, [uploadFileData])

    useEffect(() => {
        if (uploadDocumentData != null && uploadDocumentData.status === 1) {
            setLoading(false)
            alert("Document Updated")
            dispatch(clearData());
        }

    }, [uploadDocumentData])

    return (
        <>
            <div className="doc_nanny" style={{ padding: '1.5rem' }}>
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h5 style={{ margin: 0, fontWeight: 600 }}>Upload Documents</h5>
                    <Link onClick={addDiv}>
                        <AddIcon
                            style={{
                                fill: '#89d6ce',
                                width: '30px',
                                height: '30px',
                                border: '2px solid #89d6ce',
                                borderRadius: '50%',
                                padding: '4px',
                                cursor: 'pointer',
                                transition: '0.3s'
                            }}
                        />
                    </Link>
                </div>

                <div className="d-flex flex-wrap" style={{ gap: '16px' }}>
                    {documents?.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                width: '205px',
                                minHeight: '220px',
                                background: '#fff',
                                border: '1px solid #ddd',
                                borderRadius: '12px',
                                padding: '12px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div>
                                <label style={{ fontSize: '14px', fontWeight: 500 }}>
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    value={item.name}
                                    onChange={(e) => setDocumentName(e.target.value, index)}
                                    placeholder="Document Name"
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        marginTop: '6px',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px'
                                    }}
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: '12px',
                                    width: '100%',
                                    height: '100px',
                                    border: '2px dashed #ccc',
                                    borderRadius: '8px',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    background: '#f9f9f9',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center'
                                }}
                            >
                                {item.link ? (
                                    <a
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            color: '#333',
                                            fontSize: '12px',
                                            padding: '6px',
                                            'zIndex': 99999
                                        }}
                                    >
                                        <img
                                            src={fileIcon || 'https://cdn-icons-png.flaticon.com/512/337/337946.png'}
                                            alt="doc"
                                            style={{ width: '30px', height: '30px', marginBottom: '4px' }}
                                        />
                                    </a>
                                ) : (
                                    <span style={{ color: '#999', fontSize: '12px' }}>Upload file (image/pdf/doc)</span>
                                )}

                                <input
                                    type="file"
                                    accept="image/*,.pdf,.doc,.docx"
                                    onChange={(e) => setDocumentImage(e.target.files[0], index)}
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        opacity: 0,
                                        cursor: 'pointer'
                                    }}
                                />
                            </div>

                            {documents.length > 0 && (
                                <Link
                                    onClick={() => removeDiv(index)}
                                    style={{
                                        color: '#e74c3c',
                                        fontSize: '18px',
                                        position: 'absolute',
                                        top: '6px',
                                        right: '6px',
                                        cursor: 'pointer'
                                    }}
                                    title="Delete"
                                >
                                    <DeleteForever />
                                </Link>
                            )}
                        </div>
                    ))}
                </div>

                <div className="text-center mt-4">
                    {documents.length > 0 ? (
                        <Button
                            type="button"
                            onClick={handleDocuments}
                            style={{
                                backgroundColor: '#89d6ce',
                                color: '#fff',
                                padding: '8px 20px',
                                border: 'none',
                                borderRadius: '8px',
                                fontWeight: 600
                            }}
                        >
                            {loading ? <ClipLoader size={16} color="#fff" /> : 'SAVE'}
                        </Button>
                    ) : (
                        <p style={{ color: '#777', marginTop: '2rem' }}>No Documents available</p>
                    )}
                </div>
            </div>
        </>


    )
}

export default Documentsnanny
